import icons from "./icons";
import React from "react";

interface Props {
  width?: number;
  height?: number;
  src: keyof typeof icons;
  alt?: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}

export type AssetTypes = keyof typeof icons;

export default function CustomIcon({
  src,
  onClick,
  className,
  color,
  height = 20, // width&height과 viewBox의 조합으로 사이즈를 조절할 수 있음
  width = 20,
  style,
}: Props) {
  const Icon = icons[src];
  const isClickable = !!onClick;
  const cssStyle: React.CSSProperties = {
    ...style,
    cursor: isClickable ? "pointer" : "inherit",
  };

  return (
    <Icon
      onClick={onClick}
      className={className}
      width={width}
      height={height}
      style={cssStyle}
      color={color}
    />
  );
}
